module.exports = __webpack_public_path__ + "static/media/cbs-austin-article.597c2b47.svg";